// Statement-style money: always two decimals ("48,000.00"). The shared
// formatters drop trailing zeros, which on a settlement or fee line reads as
// rounding. Used wherever the wizard shows server-priced fees and settlement.
const twoDecimals = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export function formatFixedAmount(value: number): string {
  return twoDecimals.format(value)
}

export function formatFixedMoney(currency: string, value: number): string {
  return `${currency} ${formatFixedAmount(value)}`
}
